import { render, staticRenderFns } from "./NoPermissions.vue?vue&type=template&id=4612927c&scoped=true&"
import script from "./NoPermissions.vue?vue&type=script&lang=js&"
export * from "./NoPermissions.vue?vue&type=script&lang=js&"
import style0 from "./NoPermissions.vue?vue&type=style&index=0&id=4612927c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4612927c",
  null
  
)

export default component.exports